export const comments_3374305 = {"data":{"data":[],"links":{}}}